var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('head-Back',{attrs:{"title":"分享"}}),_vm._v(" "),_c('div',{staticClass:"page"}),_vm._v(" "),_c('div',{staticClass:"foot",attrs:{"id":"foot"},on:{"click":_vm.toLogin}},[_c('button',[_vm._v("立即免费开通使用")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478b3af6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/share/shareNews.vue
// module id = null
// module chunks = 